module.exports = "p-button{width:100%}p-button button{background-color:#7b96bb}\n"